import { useCallback, useEffect, useState } from 'react';

import { CATEGORIES } from '@motorway/mw-enquiry-states/static';

import { timeoutFetchSentryGuard } from 'Fetch';
import { getEnquiryData } from 'PrivateApis';

import { DPEnquiry, Vehicle, VehicleLookupState } from '../@types';

type GetVehicleEnquiry = {
  dpEnquiryId?: number;
  vehicle?: Vehicle | VehicleLookupState;
}

const useGetVehicleEnquiry = ({ dpEnquiryId, vehicle }: GetVehicleEnquiry) => {
  const [enquiry, setEnquiry] = useState<DPEnquiry>();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const { enquiry: vehicleEnquiry, id: vehicleId, vrm } = vehicle ?? {};
  const {
    dpEnquiryId: vehicleDpEnquiryId,
    dpStateSlug: vehicleDpStateSlug,
    id: vehicleEnquiryId,
    mileage,
  } = vehicleEnquiry ?? {};

  const fetchDpEnquiryId = dpEnquiryId ?? vehicleDpEnquiryId;

  const getEnquiry = useCallback(async () => {
    if (fetchDpEnquiryId) {
      return getEnquiryData(fetchDpEnquiryId, {}, 'state').catch(
        (err) => {
          timeoutFetchSentryGuard(err, () => window?.Sentry?.captureException(new Error(err), {
            extra: {
              enquiry: {
                dpEnquiryId: fetchDpEnquiryId,
                id: vehicleEnquiryId,
              },
              vehicle: {
                id: vehicleId,
                mileage,
                vrm,
              },
            },
            tags: {
              fetch: 'Fetch DP enquiry data',
            },
          }));
          return undefined;
        },
      );
    }
    return undefined;
  }, [fetchDpEnquiryId, vehicleEnquiryId, mileage, vehicleId, vrm]);

  useEffect(() => {
    const fetchEnquiry = async () => {
      const result = await getEnquiry();
      setEnquiry(result);
      setIsLoaded(true);
    };

    if (vehicleDpStateSlug !== CATEGORIES.QUOTED) {
      fetchEnquiry();
    } else {
      setIsLoaded(true);
    }
  }, [getEnquiry, vehicleDpStateSlug]);

  return { enquiry, isLoaded };
};

export default useGetVehicleEnquiry;
